module.exports = __webpack_public_path__ + "img/fiig-logo-white.6b6323d7.svg";